import { isMswEnvironment } from '@/resources/utils'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { createContext, ReactNode, useMemo } from 'react'

interface AnalyticsProps {
  writeKey: string
  children: ReactNode
}

export const shouldActivateAnalytics = !isMswEnvironment

export const AnalyticsContext = createContext<AnalyticsBrowser | undefined>(
  undefined
)

export const AnalyticsProvider = ({ children, writeKey }: AnalyticsProps) => {
  const analytics = useMemo(
    () =>
      writeKey && shouldActivateAnalytics
        ? AnalyticsBrowser.load({ writeKey })
        : undefined,
    [writeKey]
  )

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  )
}
